import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { memo, SyntheticEvent } from 'react'
import DotMenu from '../Icons/DotMenu'
import { palette } from '../styles/colors'
import { PAPER_HEIGHTS } from '../theme'
import IconButton from './IconButton'

const menuStyles = css({
    zIndex: PAPER_HEIGHTS.base,
    width: 42,
    height: 18,
    background: palette.backgroundReverse, // 'rgba(119,119,119,17%)',
    opacity: 0.5,
    padding: 7,
    borderRadius: 12,
    '&:hover': {
        background: palette.backgroundReverse,
        opacity: 0.8,
    },
})

const StyledDots = styled('span')({
    position: 'absolute',
    top: '-8px',
})

interface IButtonModelMenu {
    onClick: (e: SyntheticEvent) => void
    css?: any
    styleOverrides?: any
}

const ButtonModelMenu = ({ onClick, styleOverrides }: IButtonModelMenu) => {
    const handleOnClickDefault = (e) => {
        e.stopPropagation()
        e.preventDefault()
        onClick(e)
    }
    return (
        <IconButton
            css={[menuStyles, styleOverrides]}
            onClick={handleOnClickDefault}
            data-testid="IconButton__ModelMenu"
        >
            <StyledDots>
                <DotMenu size="33px" color={palette.background} />
            </StyledDots>
        </IconButton>
    )
}

export default memo(ButtonModelMenu)
